<template>
</template>

<script>
  //qqappid
  const qq_appId = "101581224";
  //qq回调地址
  const qq_redirectURI = "http://registerpay.gowingsoft.com/#/thirdAccountBind?thirdType=2";
  //wb_appid
  const wb_appId = "3402429559";
  //wb回调地址
  const wb_redirectURI = "http://registerpay.gowingsoft.com/#/thirdAccountBind?thirdType=3";
  //wxappid
  const wx_appId = "wx8cd99c0031013855";
  //wx回调地址
  const wx_redirectURI = "http://registerpay.gowingsoft.com/#/thirdAccountBind?thirdType=1";
  //昵称默认值
  const nickname = "无名氏";
  //性别：男（中文）
  const sex_man = "男";
  //性别：女（英文）
  const sex_female = "f";
  export default {
    name: "global",
    qq_appId,
    qq_redirectURI,
    wb_appId,
    wb_redirectURI,
    wx_appId,
    wx_redirectURI,
    nickname,
    sex_man,
    sex_female
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/global.vue